
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { BrandColours, } from '~/utils/resources';

const ValidColours = Object.getOwnPropertyNames(BrandColours);

export const ValidAlignments = [
	'centre',
	'left',
	'right',
] as const;

@Component
export default class HeaderText extends Vue {

	@Prop({
		type: Number,
		required: false,
		default: 2,
		validator(value) {
			return typeof value === 'number' && value >= 1 && value <= 6;
		},
	})
	level!: number;

	@Prop({
		type: String,
		required: false,
		validator(value) {
			return !value || (typeof value === 'string' && (ValidAlignments as readonly string[]).includes(value));
		},
	})
	alignment?: string;

	@Prop({
		type: String,
		required: false,
		validator(value) {
			return typeof value === 'string' && ValidColours.includes(value);
		},
	})
	colour?: string;

	@Prop({
		type: String,
		required: true,
	})
	title!: string;

	@Prop({
		type: String,
		required: false,
	})

	subTitle?: string;

	@Prop({
		type: String,
		required: false,
		validator(value) {
			return !value || (typeof value === 'string' && ValidColours.includes(value));
		},
	})
	subTitleColour?: string;

	@Prop({
		type: Boolean,
		required: false,
	})
	headingStyle = false;

	get headingTag() {
		return `h${this.level}`;
	}

	get subHeadingTag() {
		return `h${this.level + 1}`;
	}
}
